export default () => ({
  contentData: {},
  isContentLoaded: false,
});
